import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  createPaymentTransactionForInvoiceFromEncryptedQueryStringV3,
  createPaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3,
  getPaymentTransactionStatusFromEncryptedQueryStringV3,
} from '../services/FinancialsPublicV3Service';

export const useFinancialsPublicV3CreatePaymentTransactionForInvoiceFromEncryptedQueryStringV3 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createPaymentTransactionForInvoiceFromEncryptedQueryStringV3, 'requestBody', 'data'),
      'data',
      'paymentAmount',
      'merchantReturnUrl',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['paymentAmount', 'merchantReturnUrl'] },
    ],
  },
);

export const useFinancialsPublicV3CreatePaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3 =
  createMutationHook(
    collapseDataFromCall(
      collapseParams(
        collapseParams(createPaymentTransactionForPaymentArrangementFromEncryptedQueryStringV3, 'requestBody', 'data'),
        'data',
        'paymentAmount',
        'merchantReturnUrl',
      ),
    ),
    {
      injectables: ['label', 'businessUnit'],
      flattenData: true,
      flattenBodyPairs: [
        { target: 'requestBody', props: ['data'] },
        { target: 'data', props: ['paymentAmount', 'merchantReturnUrl'] },
      ],
    },
  );

export const useFinancialsPublicV3GetPaymentTransactionStatusFromEncryptedQueryStringV3 = createDCHook(
  'getPaymentTransactionStatusFromEncryptedQueryStringV3',
  collapseDataFromCall(getPaymentTransactionStatusFromEncryptedQueryStringV3),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
